/**
 * @generated SignedSource<<92daf38ab676a03ccac608a9bb882cec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topStoriesOlympicQueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"olympicsTopStoryContentItemContent">;
  };
  readonly " $fragmentType": "topStoriesOlympicQueueItemsEdge";
}>;
export type topStoriesOlympicQueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: topStoriesOlympicQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"topStoriesOlympicQueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "topStoriesOlympicQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "olympicsTopStoryContentItemContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "3a7e1932548323503ddd70f05c995d5a";

export default node;
